import styled from "styled-components";

const Intro = styled.p`
  font-size: 25px;
  font-weight: bold;
  margin: 0 auto;
`;

export default Intro;
